export default __webpack_public_path__ + "static/media/icon-ecom-soft-round.aa8e044b.svg";